module.exports = __webpack_public_path__ + "static/media/mq.27503972.svg";